import { IonToolbar, IonButtons, IonTitle, IonBackButton, IonPage, IonContent } from "@ionic/react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUserDocuments } from "../../store/userShow/selectors/selectuserDocuments";
import { UserFile } from "../../@types/userFiles";
import { UploadDocument } from "./components/UploadDocument";
import {RejectedDocumentUpdate} from "./components/RejectedDocumentUpdate";
import { selectUser } from "../../store/userAuthentication/selectors/selectUser";


export const SupervisorUserDocumentUpload = () => {
  const { id }: { id: string } = useParams();
  const { userId }: { userId: string } = useParams();
  const user = useSelector(selectUser);

  const userDocumentsList = useSelector(selectUserDocuments);
  const selectedDocument: UserFile[] = userDocumentsList!.filter(
    (document) => document.id?.toString() == id
  );


  return (
    <>
      <IonPage>
        <IonContent>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton color="light" defaultHref={`/app/supervision/colaborador/${userId}`} />
            </IonButtons>
            <IonTitle>Subir Documento</IonTitle>
          </IonToolbar>
          <section className="ion-padding">
            {selectedDocument.length > 0 && selectedDocument[0].documents.length === 0 && (
              <UploadDocument document={selectedDocument} userId={userId} ownerId={user?.id!} />
            )}
            {selectedDocument.length > 0 && selectedDocument[0].documents.length > 0 && 
              (<RejectedDocumentUpdate document={selectedDocument} userId={userId} ownerId={user?.id!} />)
            }
          </section>
        </IonContent>
      </IonPage>
    </>
  );
};
